class Inscripcio {
    constructor(
        public key = 0,
        public id = 0,
        public cognom = "",
        public dni = "",
        public alta = "",
        public actiu = 0,
        public id_activitat = 0,
        public activitat = "",
        public autoritzacio1 = 0,
        public autoritzacio2 = 0,
        public autoritzacio3 = 0,
        public estat = "",
    ) {
        this.key = key;
        this.id = id;
        this.cognom = cognom;
        this.dni = dni;
        this.alta = alta;
        this.actiu = actiu;
        this.id_activitat = id_activitat;
        this.activitat = activitat;
        this.autoritzacio1 =autoritzacio1;
        this.autoritzacio2 = autoritzacio2;
        this.autoritzacio3 = autoritzacio3;
        this.estat = estat;
    }
}

export default Inscripcio;
